import { defineStore } from "pinia";
import { showError } from "src/utils/notify";
import {
  KlaviyoEventTypes,
  useklaviyoEventsStores,
} from "./klaviyo-events-store";

export const useSwagshopStore = defineStore("swagshop", {
  state: () => ({
    products: [],
    loadProducts: false,
    infiniteScrollIndex: 0,
    scrollPosition: 0,
    productDetail: {},
    loadProductDetail: false,
    productReviews: [],
    loadProductReviews: false,
    productAttributes: {},
    loadProductAttributes: false,
    selectedAttribute: {},
    matchedPairing: {},
    quantity: 1,
    purchaseAmount: "",
    swagShopFilters: {},
    categories: {},
    tags: {},
    productMaxPoints: 0,
    confirmPurchaseFilters: {
      toggleGiftPurchase: false,
      toggleStorePickup: false,
      toggleStandardShipping: false,
      gift: {
        message: "",
        friendInfo: null,
        redemptionDate: "",
        // redemptionDate: new Date().toISOString().split("T")[0],
      },
      selectedLocation: null,
      selectedShippingAddress: null,
    },
    storeLocations: [],
    loadStoreLocations: false,
    storePurchases: [],
    loadStorePurchases: false,
    purchaseDetail: {},
    loadPurchaseDetail: false,
    filterAt: "store",
    storeLocationsFooter: [],
    loadStoreLocationsFooter: false,
  }),
  getters: {
    productsList: (state) => {
      return state.products;
    },
    getScrollPosition: (state) => {
      return state.scrollPosition;
    },
    getSwagShopFilters: (state) => {
      return state.swagShopFilters;
    },
    getStoreFilterCategories: (state) => state.categories,
    getStoreFilterTags: (state) => state.tags,
    getSelectedAttribute: (state) => state.selectedAttribute,
    getMatchedPairing: (state) => state.matchedPairing,
    getProductQuantity: (state) => state.quantity,
    getPurchaseAmount: (state) => state.purchaseAmount,
    getConfirmPurchaseFilters: (state) => state.confirmPurchaseFilters,
  },
  actions: {
    async getProductsList(params, options) {
      try {
        let URL, response;
        switch (options.category) {
          case "mfg":
            URL = this.apiEndpoints.SWAGSHOP_MFG_PRODUCTS;
            break;
          default:
            URL = this.apiEndpoints.SWAGSHOP_STORE_PRODUCTS;
            break;
        }
        if (URL) {
          response = await this.$request.post(URL, params);
          if (response.data) {
            // this.products = response.data.items || [];
            if (params.page == 1) {
              this.productMaxPoints = 0;
              this.products = response.data.items;
            } else {
              this.products = [
                ...this.products,
                ...(response.data.items || []),
              ];
            }
            this.loadProducts = true;
            this.infiniteScrollIndex = params.page;
            // if (this.productMaxPoints < response.data.max_points) {
            //   this.productMaxPoints = response.data.max_points;
            // }
          }
          return response.data;
        } else {
          return {};
        }
      } catch (error) {
        //console.log("FromAPI:-" + error);
        showError(error.message);
      }
    },
    async getProductDetail(id, options) {
      try {
        this.loadProductDetail = false;
        let URL, response;
        switch (options.category) {
          case "store":
            URL = this.apiEndpoints.PRODUCT_DETAIL(id);
            break;
          case "mfg":
            URL = this.apiEndpoints.MFG_PRODUCT_DETAIL(id);
            break;
        }
        if (URL) {
          response = await this.$request.get(URL);
          if (response.data && response.data.item) {
            this.productDetail = response.data;
            this.loadProductDetail = true;
          }
          if (options.category == "store") {
            const klaviyoStore = useklaviyoEventsStores();
            klaviyoStore.addKlaviyoEvent({
              event_name: KlaviyoEventTypes.VIEWED_SWAG_ITEM,
              item_id: id,
              store_id: this.productDetail.item.store_id,
            });
          }
          return response.data;
        } else {
          return {};
        }
      } catch (error) {
        //console.log("FromAPI:-" + error);
        showError(error.message);
      }
    },
    async getProductReviews(id, options) {
      try {
        this.loadProductReviews = false;
        let URL, response;
        switch (options.category) {
          case "store":
            URL = this.apiEndpoints.PRODUCT_REVIEWS(id);
            break;
          case "mfg":
            URL = this.apiEndpoints.MFG_PRODUCT_REVIEWS(id);
            break;
        }
        if (URL) {
          response = await this.$request.get(URL);
          if (response.data) {
            this.productReviews = response.data.items || [];
            this.loadProductReviews = true;
          }
          return response.data;
        } else {
          return {};
        }
      } catch (error) {
        //console.log("FromAPI:-" + error);
        showError(error.message);
      }
    },
    async getProductAttributes(id, options) {
      try {
        this.loadProductAttributes = false;
        let URL, response;
        switch (options.category) {
          case "store":
            URL = this.apiEndpoints.PRODUCT_ATTRIBUTES(id);
            break;
          case "mfg":
            URL = this.apiEndpoints.MFG_PRODUCT_ATTRIBUTES(id);
            break;
        }
        if (URL) {
          response = await this.$request.get(URL);
          if (response.data) {
            this.productAttributes = response.data.item || {};
            this.loadProductAttributes = true;
            for (let attribute of this.productAttributes.attribute_info
              .attributes) {
              this.selectedAttribute[attribute.name] = attribute.values[0];
            }
          }
          return response.data;
        } else {
          return {};
        }
      } catch (error) {
        //console.log("FromAPI:-" + error);
        showError(error.message);
      }
    },
    setProductAttributes({ key, value }) {
      this.selectedAttribute[key] = value;
    },
    setMatchedPairing(payload) {
      this.matchedPairing = payload;
    },
    setProductQuantity(qty) {
      this.quantity = qty;
    },
    setPurchaseAmount(amount) {
      this.purchaseAmount = amount;
    },
    async addProductReview(params, review, options) {
      try {
        let URL, response;
        switch (options.category) {
          case "store":
            URL = this.apiEndpoints.PRODUCT_DETAIL_ADD_REVIEW(options.id);
            break;
          case "mfg":
            URL = this.apiEndpoints.MFG_PRODUCT_DETAIL_ADD_REVIEW(options.id);
            break;
        }
        if (URL) {
          response = await this.$request.post(URL, params);
          if (response.data) {
            this.productReviews.unshift(review);
            this.productDetail = Object.assign({}, this.productDetail, {
              has_reviewed: 1,
              rating:
                (this.productDetail.item.rating + params.rating) /
                (this.productDetail.item.review_count + 1),
              review_count: this.productDetail.item.review_count + 1,
            });

            // update products array as well
            let productIndex = this.products.findIndex(
              (product) => product.id === this.productDetail.item.id
            );
            if (productIndex != -1) {
              let product = JSON.parse(
                JSON.stringify(this.products[productIndex])
              );
              product = Object.assign({}, product, {
                has_reviewed: 1,
                rating:
                  (product.rating + params.rating) / (product.review_count + 1),
                review_count: product.review_count + 1,
              });
              this.products = Object.assign([], this.products, {
                [productIndex]: product,
              });
            }
          }
          return response.data;
        } else {
          return {};
        }
      } catch (error) {
        //console.log("FromAPI:-" + error);
        showError(error.message);
      }
    },
    resetProducts() {
      this.products = [];
      this.loadProducts = false;
      this.infiniteScrollIndex = 0;
      this.scrollPosition = 0;
    },
    resetProductDetail() {
      this.productDetail = {};
      this.loadProductDetail = false;
      this.productReviews = [];
      this.loadProductReviews = false;
      this.productAttributes = {};
      this.loadProductAttributes = false;
      this.selectedAttribute = {};
      this.matchedPairing = {};
      this.quantity = 1;
    },
    setScrollPosition(position) {
      this.scrollPosition = position;
    },
    async addStoreProductToWishlist(params) {
      try {
        let response = await this.$request.post(
          this.apiEndpoints.ADD_STORE_TO_WISHLIST,
          params
        );
        if (response && response.data && response.data.status) {
          let productIndex = this.products.findIndex(
            (product) => product.id === params.product_id
          );
          if (productIndex != -1) {
            let product = JSON.parse(
              JSON.stringify(this.products[productIndex])
            );
            product.is_on_wishlist = 1;
            this.products = Object.assign([], this.products, {
              [productIndex]: product,
            });

            if (
              this.productDetail.item &&
              this.productDetail.item?.id &&
              this.productDetail.item?.id == product.id
            )
              this.productDetail.item.is_on_wishlist = 1;
          } else {
            if (this.productDetail.item?.id)
              this.productDetail.item.is_on_wishlist = 1;
          }
        }
        return response.data;
      } catch (error) {
        //console.log("FromAPI:-" + error);
        showError(error.message);
      }
    },
    async removeStoreProductToWishlist(params, removeProduct = false) {
      try {
        let response = await this.$request.post(
          this.apiEndpoints.REMOVE_STORE_FROM_WISHLIST,
          params
        );
        if (response && response.data && response.data.status) {
          let productIndex = this.products.findIndex(
            (product) => product.id === params.product_id
          );
          if (productIndex != -1) {
            if (removeProduct) {
              this.products.splice(productIndex, 1);
            } else {
              let product = JSON.parse(
                JSON.stringify(this.products[productIndex])
              );
              product.is_on_wishlist = 0;
              this.products = Object.assign([], this.products, {
                [productIndex]: product,
              });

              if (
                this.productDetail.item &&
                this.productDetail.item?.id &&
                this.productDetail.item?.id == product.id
              )
                this.productDetail.item.is_on_wishlist = 0;
            }
          } else {
            if (this.productDetail.item?.id)
              this.productDetail.item.is_on_wishlist = 0;
          }
        }
        return response.data;
      } catch (error) {
        //console.log("FromAPI:-" + error);
        showError(error.message);
      }
    },
    async addMFGProductToWishlist(params) {
      try {
        let response = await this.$request.post(
          this.apiEndpoints.ADD_MFG_TO_WISHLIST,
          params
        );
        if (response && response.data && response.data.status) {
          let productIndex = this.products.findIndex(
            (product) => product.id === params.product_id
          );
          if (productIndex != -1) {
            let product = JSON.parse(
              JSON.stringify(this.products[productIndex])
            );
            product.is_on_wishlist = 1;
            this.products = Object.assign([], this.products, {
              [productIndex]: product,
            });

            if (
              this.productDetail.item &&
              this.productDetail.item?.id &&
              this.productDetail.item?.id == product.id
            )
              this.productDetail.item.is_on_wishlist = 1;
          } else {
            if (this.productDetail.item?.id)
              this.productDetail.item.is_on_wishlist = 1;
          }
        }
        return response.data;
      } catch (error) {
        //console.log("FromAPI:-" + error);
        showError(error.message);
      }
    },
    async removeMFGProductToWishlist(params, removeProduct = false) {
      try {
        let response = await this.$request.post(
          this.apiEndpoints.REMOVE_MFG_FROM_WISHLIST,
          params
        );
        if (response && response.data && response.data.status) {
          let productIndex = this.products.findIndex(
            (product) => product.id === params.product_id
          );
          if (productIndex != -1) {
            if (removeProduct) {
              this.products.splice(productIndex, 1);
            } else {
              let product = JSON.parse(
                JSON.stringify(this.products[productIndex])
              );
              product.is_on_wishlist = 0;
              this.products = Object.assign([], this.products, {
                [productIndex]: product,
              });

              if (
                this.productDetail.item &&
                this.productDetail.item?.id &&
                this.productDetail.item?.id == product.id
              )
                this.productDetail.item.is_on_wishlist = 0;
            }
          } else {
            if (this.productDetail.item?.id)
              this.productDetail.item.is_on_wishlist = 0;
          }
        }
        return response.data;
      } catch (error) {
        //console.log("FromAPI:-" + error);
        showError(error.message);
      }
    },
    setSwagShopFilters(params) {
      this.swagShopFilters = {
        ...params,
      };
    },
    resetSwagShopFilters() {
      this.swagShopFilters = {};
    },
    async getSwagShopCategories(storeId) {
      try {
        let data = await this.$request.post(
          this.apiEndpoints.SWAG_SHOP_FILTER_CATEGORIES,
          { store_id: storeId }
        );
        if (data && data.status) {
          this.categories = data.data.items;
        } else {
          this.categories = [];
        }
      } catch (error) {}
    },
    async getSwagShopAllCategories() {
      try {
        let data = await this.$request.get(
          this.apiEndpoints.SWAG_SHOP_FILTER_ALL_CATEGORIES
        );
        if (data && data.status) {
          this.categories = data.data.items;
        } else {
          this.categories = [];
        }
      } catch (error) {}
    },
    async getSwagShopTags(storeId) {
      try {
        let data = await this.$request.post(
          this.apiEndpoints.SWAG_SHOP_FILTER_TAGS,
          {
            store_id: storeId,
          }
        );
        if (data && data.status) {
          this.tags = data.data.items;
        } else {
          this.tags = [];
        }
      } catch (error) {}
    },
    async getSwagShopMfgCategories(mfgId) {
      try {
        let data = await this.$request.post(
          this.apiEndpoints.SWAG_SHOP_MFG_FILTER_CATEGORIES,
          { manufacturer_id: mfgId }
        );
        if (data && data.status) {
          this.categories = data.data.items;
        } else {
          this.categories = [];
        }
      } catch (error) {}
    },
    async getSwagMfgShopTags(mfgId) {
      try {
        let data = await this.$request.post(
          this.apiEndpoints.SWAG_SHOP_MFG_FILTER_TAGS,
          {
            manufacturer_id: mfgId,
          }
        );
        if (data && data.status) {
          this.tags = data.data.items;
        } else {
          this.tags = [];
        }
      } catch (error) {}
    },
    resetConfirmPurchaseFilters() {
      this.confirmPurchaseFilters = {
        toggleGiftPurchase: false,
        toggleStorePickup: false,
        toggleStandardShipping: false,
        gift: {
          message: "",
          friendInfo: null,
          redemptionDate: "",
        },
        selectedLocation: null,
        selectedShippingAddress: null,
      };
      this.purchaseAmount = "";
    },
    resetConfirmPurchaseFilterByType(type) {
      switch (type) {
        case "gift":
          if (this.confirmPurchaseFilters.toggleGiftPurchase) {
            this.confirmPurchaseFilters.toggleStorePickup = false;
            this.confirmPurchaseFilters.toggleStandardShipping = false;
            this.confirmPurchaseFilters.selectedLocation = null;
            this.confirmPurchaseFilters.selectedShippingAddress = null;
          }
          break;
        case "storepickup":
          if (this.confirmPurchaseFilters.toggleStorePickup) {
            this.confirmPurchaseFilters.toggleGiftPurchase = false;
            this.confirmPurchaseFilters.toggleStandardShipping = false;
            this.confirmPurchaseFilters.gift = {
              message: "",
              friendInfo: null,
              redemptionDate: "",
            };
            this.confirmPurchaseFilters.selectedShippingAddress = null;
          }
          break;
        case "standardshipping":
          if (this.confirmPurchaseFilters.toggleStandardShipping) {
            this.confirmPurchaseFilters.toggleGiftPurchase = false;
            this.confirmPurchaseFilters.toggleStorePickup = false;
            this.confirmPurchaseFilters.gift = {
              message: "",
              friendInfo: null,
              redemptionDate: "",
            };
            this.confirmPurchaseFilters.selectedLocation = null;
          }
          break;
      }
    },
    async getStoreLocations(id, options, param = {}) {
      try {
        this.loadStoreLocations = false;
        this.storeLocations = [];
        let URL, response, Request;
        switch (options.category) {
          case "store":
            URL = this.apiEndpoints.STORE_LOCATIONS(id);
            param.acc = id;
            Request = this.$request.post(URL, param);
            break;
          case "mfg":
            URL = this.apiEndpoints.MFG_LOCATIONS(id);
            Request = this.$request.get(URL);
            break;
        }
        if (URL) {
          response = await Request;
          if (response.data) {
            this.storeLocations = response.data.items;
            this.loadStoreLocations = true;
          }
          return response.data;
        } else {
          return {};
        }
      } catch (error) {
        //console.log("FromAPI:-" + error);
        showError(error.message);
      }
    },
    async getPurchaseHistory(params, options) {
      try {
        let URL, response;
        switch (options.category) {
          case "store":
            URL = this.apiEndpoints.STORE_PURCHASES;
            break;
          case "mfg":
            URL = this.apiEndpoints.MFG_PURCHASES;
            break;
        }
        if (URL) {
          response = await this.$request.post(URL, params);
          if (response.data) {
            if (params.page == 1) {
              this.storePurchases = response?.data?.items || [];
            } else {
              Array.prototype.push.apply(
                this.storePurchases,
                response.data.items || []
              );
            }
            this.infiniteScrollIndex = params.page;
            this.loadStorePurchases = true;
          }
          return response.data;
        } else {
          return {};
        }
      } catch (error) {
        //console.log("FromAPI:-" + error);
        showError(error.message);
      }
    },
    async getPurchaseDetail(id, options) {
      try {
        this.loadPurchaseDetail = false;
        let URL, response;
        switch (options.category) {
          case "store":
            URL = this.apiEndpoints.STORE_PURCHASE_DETAIL(id);
            break;
          case "mfg":
            URL = this.apiEndpoints.MFG_PURCHASE_DETAIL(id);
            break;
        }
        if (URL) {
          response = await this.$request.get(URL);
          if (response.data) {
            this.purchaseDetail = response.data.item;
            this.loadPurchaseDetail = true;
          }
          return response.data;
        } else {
          return {};
        }
      } catch (error) {
        //console.log("FromAPI:-" + error);
        showError(error.message);
      }
    },
    resetStorePurchase() {
      this.storePurchases = [];
      this.loadStorePurchases = false;
      this.infiniteScrollIndex = 0;
      this.scrollPosition = 0;
    },
    resetPurchaseDetail() {
      this.purchaseDetail = {};
      this.loadPurchaseDetail = false;
    },
    setFilterAt(filterAt) {
      this.filterAt = filterAt;
    },
    resetCategoryAndTags() {
      if (this.swagShopFilters) {
        this.swagShopFilters.category = undefined;
      }
    },
    async makePurchase(id, params, options) {
      try {
        let URL, response;
        switch (options.category) {
          case "store":
            URL = options.isDigital
              ? this.apiEndpoints.STORE_CONFIRM_PURCHASE(id) + "/digital-coupon"
              : this.apiEndpoints.STORE_CONFIRM_PURCHASE(id);
            break;
          case "mfg":
            URL = this.apiEndpoints.MFG_CONFIRM_PURCHASE(id);
            break;
        }
        if (URL) {
          response = await this.$request.post(URL, params);
          return response.data;
        } else {
          return {};
        }
      } catch (error) {
        //console.log("FromAPI:-" + error);
        showError(error.message);
      }
    },
    resetStoreLocations() {
      this.loadStoreLocations = false;
      this.storeLocations = [];
    },
    async getStoreLocationsForFooter(id, options, param = {}) {
      try {
        this.loadStoreLocations = false;
        this.storeLocations = [];
        let URL, response, Request;
        switch (options.category) {
          case "store":
            URL = this.apiEndpoints.STORE_LOCATIONS(id);
            param.acc = id;
            Request = this.$request.post(URL, param);
            break;
          case "mfg":
            URL = this.apiEndpoints.MFG_LOCATIONS(id);
            Request = this.$request.get(URL);
            break;
        }
        if (URL) {
          response = await Request;
          if (response.data) {
            this.storeLocationsFooter = response.data.items;
            this.loadStoreLocationsFooter = true;
          }
          return response.data;
        } else {
          return {};
        }
      } catch (error) {
        //console.log("FromAPI:-" + error);
        showError(error.message);
      }
    },
  },
});
